import { render, staticRenderFns } from "./ReportPromoItem.vue?vue&type=template&id=2ce043a0"
import script from "./ReportPromoItem.vue?vue&type=script&lang=js"
export * from "./ReportPromoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports